export const TUTORIAL_ACTIVE_FLAG = "reqxign_tutorial_active";

export const TUTORIAL_EVENTS = {
  START_TOUR: "tutorial:start-tour",
  NEXT_STEP: "tutorial:next-step",
  COMPLETE_TOUR: "tutorial:complete",
};

export const startTutorialTour = () => {
  if (typeof window !== "undefined") {
    localStorage.setItem(TUTORIAL_ACTIVE_FLAG, "true");
    localStorage.removeItem("reqxign_tutorial_hidden_sample");
  }
  const event = new CustomEvent(TUTORIAL_EVENTS.START_TOUR);
  window.dispatchEvent(event);
};

export const onTutorialTourStart = (callback: () => void) => {
  const handler = () => callback();
  window.addEventListener(TUTORIAL_EVENTS.START_TOUR, handler);
  return () => window.removeEventListener(TUTORIAL_EVENTS.START_TOUR, handler);
};

export const advanceTutorialStep = () => {
  if (typeof window === "undefined") return;
  const event = new CustomEvent(TUTORIAL_EVENTS.NEXT_STEP);
  window.dispatchEvent(event);
};

export const completeTutorialTour = () => {
  if (typeof window === "undefined") return;
  const event = new CustomEvent(TUTORIAL_EVENTS.COMPLETE_TOUR);
  window.dispatchEvent(event);
};
